import { Component, inject, input, InputSignal } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import { EventLoggerService } from '@services/event-logger-service';
import {
  PriceDetailsBottomsheetComponent,
  PriceDetailsBottomsheetData,
} from '@shared/bottom-sheet-layouts/price-details-bottomsheet/price-details-bottomsheet.component';

export interface PricingDetails {
  totalMrp: number;
  totalSP: number;
  discountInRupees: number;
}

@Component({
  selector: 'app-to-pay',
  imports: [CsIconModule],
  templateUrl: './to-pay.component.html',
})
export class ToPayComponent {
  pricingDetails: InputSignal<PricingDetails> = input.required<PricingDetails>();
  bottomsheetData: InputSignal<PriceDetailsBottomsheetData> = input.required<PriceDetailsBottomsheetData>();

  private readonly bottomSheet = inject(MatBottomSheet);
  private readonly eventLoggerService = inject(EventLoggerService);

  openPriceDetailSheet(): void {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'price_details_sheet' }));
    this.bottomSheet.open(PriceDetailsBottomsheetComponent, {
      data: this.bottomsheetData(),
    });
  }
}
